// extracted by mini-css-extract-plugin
export default {"signatureHeader":"styles_signatureHeader__5wqfP"};